export default "__VITE_ASSET__C8Rk6ZzU__"